import { useEffect, useState } from "react";
import useApprovedCollectionsInfiniteQuery from "views/Collection/hooks/usePublicCollectionsInfiniteQuery";
import DSAutocomplete from "views/system-design/DSAutocomplete";
import DSTextField from "views/system-design/DSTextField";

export type PickedCollection = { id: string; name: string };

type Props = {
  value: PickedCollection | null;
  onChange: (collection: PickedCollection | null) => void;
  disabled?: boolean;
};

/** Searches the approved collections by name. */
const CreativeCollectionPicker = ({ value, onChange, disabled }: Props) => {
  const [input, setInput] = useState("");
  const [search, setSearch] = useState("");

  // Wait for the user to stop typing before asking the API.
  useEffect(() => {
    const timer = setTimeout(() => setSearch(input.trim()), 300);
    return () => clearTimeout(timer);
  }, [input]);

  const { data, isLoading } = useApprovedCollectionsInfiniteQuery(
    search,
    20,
    false,
  );
  const options: PickedCollection[] = (data ?? []).map(({ id, name }) => ({
    id,
    name,
  }));

  return (
    <DSAutocomplete<PickedCollection>
      size="small"
      options={options}
      loading={isLoading}
      value={value}
      disabled={disabled}
      // The API already filtered by the typed text.
      filterOptions={(items) => items}
      getOptionLabel={(collection) => collection.name}
      isOptionEqualToValue={(option, current) => option.id === current.id}
      onChange={(_event, collection) => onChange(collection)}
      onInputChange={(_event, text, reason) => {
        if (reason === "input" || reason === "clear") setInput(text);
      }}
      noOptionsText="No collections found"
      renderInput={(params) => (
        <DSTextField
          {...params}
          label="Collection (optional)"
          placeholder="Search a collection by name"
        />
      )}
    />
  );
};

export default CreativeCollectionPicker;
